export default __webpack_public_path__ + "static/media/proximanova-bold-webfont.67a5122c.woff2";